import { useState } from "react";
import { Section, Eyebrow, ChromeHeading, Card, Lightbox } from "../funnel";
import { ResultsMasonry } from "./ResultsMasonry";
import { RESULT_SHOTS, INITIAL_SHOTS } from "../../data/results";

const STATS = [
  ["+184", "points on one bureau"],
  ["45", "negative items deleted on one file"],
  ["$95K", "business credit line, offer accepted"],
];

export const Receipts = () => {
  const [expanded, setExpanded] = useState(false);
  const [active, setActive] = useState(null);
  const hidden = RESULT_SHOTS.length - INITIAL_SHOTS;
  const shots = expanded ? RESULT_SHOTS : RESULT_SHOTS.slice(0, INITIAL_SHOTS);

  return (
    <Section data-testid="receipts-section">
      <div className="max-w-3xl">
        <Eyebrow>RECEIPTS</Eyebrow>
        <ChromeHeading className="mt-4 text-4xl sm:text-5xl lg:text-6xl">Real approvals. Real reports.</ChromeHeading>
        <p className="mt-5 text-[13px] leading-relaxed text-[#9d968a]">Specific past results from specific clients, shared with permission and with personal details blacked out. Not typical and not a guarantee. We review negative, inaccurate, incomplete, or unverifiable information and explain the appropriate options for addressing it. Accurate information can stay on a report.</p>
      </div>
      <div className="mt-10 grid gap-4 sm:grid-cols-3">
        {STATS.map(([big, label], i) => (
          <Card key={big} className="px-6 py-6" data-testid={`receipts-stat-${i + 1}`}>
            <p><span className="font-display gold-text block text-5xl leading-none">{big}</span> <span className="mt-2 block text-[14px] text-[#d8d0bf]">{label}</span></p>
          </Card>
        ))}
      </div>
      <ResultsMasonry shots={shots} onOpen={setActive} />
      <div className="mt-10 flex justify-center">
        <button type="button" onClick={() => setExpanded((v) => !v)} className="font-mono-plex rounded-full border border-[rgba(232,184,74,0.55)] px-6 py-3 text-[12px] uppercase tracking-[0.2em] text-[var(--gold)] transition-[background-color,transform] duration-200 hover:-translate-y-px hover:bg-[rgba(232,184,74,0.1)]" data-testid="receipts-toggle-button" aria-expanded={expanded}>
          {expanded ? "Show fewer results" : `See ${hidden} more results`}
        </button>
      </div>
      <Lightbox item={active} onClose={() => setActive(null)} />
    </Section>
  );
};
